/* DocAttachTrigger — Bouton minuscule qui ouvre un drawer avec
 * <DocumentAttachZone> à l'intérieur. Utilisé sur les modules sans fiche
 * détail dédiée (Audits, Incidents, PlansAction, Fournisseurs, Leads…)
 * pour permettre d'attacher des docs Noam Drive depuis chaque ligne.
 *
 * Props : module, entityId, entityLabel, count (optionnel — pour badge)
 */
import { useState } from "react";
import { Paperclip, X } from "lucide-react";
import DocumentAttachZone from "@/components/DocumentAttachZone";

export default function DocAttachTrigger({ module, entityId, entityLabel, className = "" }) {
  const [open, setOpen] = useState(false);
  if (!module || !entityId) return null;
  return (
    <>
      <button
        type="button"
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className={`inline-flex items-center gap-1 text-[10px] uppercase tracking-wider text-zinc-500 hover:text-[#378ADD] transition-colors ${className}`}
        data-testid={`doc-attach-trigger-${module}-${entityId}`}
        title="Documents Noam Drive"
      >
        <Paperclip className="w-3 h-3" /> Docs
      </button>
      {open && (
        <div
          className="fixed inset-0 z-50 bg-black/70 backdrop-blur-sm flex items-center justify-center p-4"
          onClick={() => setOpen(false)}
          data-testid={`doc-attach-drawer-${entityId}`}
        >
          <div className="noam-card max-w-xl w-full p-5 space-y-3" onClick={(e) => e.stopPropagation()}>
            <div className="flex items-center justify-between">
              <div>
                <div className="noam-overline">Noam Drive</div>
                <div className="text-sm font-semibold text-zinc-200 truncate">
                  Documents attachés{entityLabel ? ` — ${entityLabel}` : ""}
                </div>
              </div>
              <button onClick={() => setOpen(false)} className="text-zinc-400 hover:text-white">
                <X className="w-4 h-4" />
              </button>
            </div>
            <DocumentAttachZone
              module={module}
              entityId={entityId}
              entityLabel={entityLabel}
            />
          </div>
        </div>
      )}
    </>
  );
}
